
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kompetisi/transporter",
      function () {
        return require("private-next-pages/kompetisi/transporter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kompetisi/transporter"])
      });
    }
  